module.exports = __webpack_public_path__ + "img/site.7fc3d968.svg";